import { defineMessages } from 'react-intl';

export default defineMessages({
  sectionAriaLabel: {
    id: 'frontbucket.repository.prListCard.sectionAriaLabel',
    description: 'Label for a sidebar card with section naming',
    defaultMessage: 'Pull Request List',
  },
  headingAriaLabel: {
    id: 'frontbucket.repository.prListCard.headingAriaLabel',
    description:
      'Label for a sidebar heading card showing a list pull requests and their statuses.',
    defaultMessage:
      '{prCount} {prCount, plural, one {pull request} other {pull requests}}',
  },
  prCount: {
    id: 'frontbucket.repository.prListCard.prCount',
    description:
      'Label for displaying the number of pull requests related to this branch.',
    defaultMessage:
      '{total, plural, one {{prCount} pull request} other {{prCount} pull requests}}',
  },
  prListErrorMessage: {
    id: 'frontbucket.repository.prListCard.errorMessage',
    description: 'Error fetching pull request list',
    defaultMessage: "Couldn't load pull requests.",
  },
  noPRs: {
    id: 'frontbucket.repository.prListCard.headerActions.noPRs',
    description: 'Text to display PR list card when there are no PRs',
    defaultMessage: 'No pull requests',
  },
});
